// Values are not they just need to be unique so we can create all the tables till we actually implement them
// details https://oliasoft.atlassian.net/browse/OW-14122

export enum KnowEdmTableData {
  GeodeticDatum = 'geodeticDatum',
  MapSystem = 'mapSystem',
  MapZone = 'mapZone',
  EPSGCode = 'epsgCode',
  TieOnReference = 'tieOnReference',
  TieOnDepthReference = 'tieOnDepthReference',
  TieOnPosition = 'tieOnPosition',
  WellboreWellheadPosition = 'wellboreWellheadPosition',
  GeographicalLongitude = 'longitude',
  GeographicalLatitude = 'latitude',
  MapPositionEW = 'mapPositionEW',
  MapPositionNS = 'mapPositionNS',
  LocalPositionEW = 'localPositionEW',
  LocalPositionNS = 'localPositionNS',
  LocalOffsetNorth = 'localOffsetNorth',
  LocalOffsetEast = 'localOffsetEast',
  Easting = 'easting',
  Northing = 'northing',
  DistanceToReferencePosition = 'distanceToReferencePoint',
  ReferencePositionType = 'referencePositionType',
  ReferenceSlotName = 'referenceSlotName',
  ReferenceSiteName = 'referenceSiteName',
}
